<app-menu-riot></app-menu-riot>
<div class="content">
    <div class="logo">
        <img src="https://playforgood.io/wp-content/uploads/2021/04/logo-league-of-legends.png"
             alt="logo-league-of-legends">
    </div>
    <div class="lol-info">
        <div class="container">
            <p><a href="https://euw.leagueoflegends.com/fr-fr/" target="_blank">League of Legends</a> (abrégé LoL) est
                un jeu vidéo sorti en 2009 de type arène de bataille en ligne,
                free-to-play, développé et édité par <a href="https://www.riotgames.com/fr" target="_blank">Riot
                    Games</a>.
            </p>
            <p>Le mode principal du jeu voit s’affronter deux équipes de 5 joueurs en temps réel dans des parties d’une
                durée d’environ une demi-heure, chaque équipe occupant et défendant sa propre base sur la carte.
            </p>
            <p>League of Legends est souvent considéré comme le jeu vidéo ayant la plus large scène compétitive au
                monde, ses compétitions étant internationales et réunissant d’importantes audiences. Le Championnat du
                monde de League of Legends 2019, par exemple, réunissait plus de 44 millions de spectateurs en
                simultanés lors de ses pics de popularité.
            </p>
            <p>Source : <a href="https://fr.wikipedia.org/wiki/League_of_Legends" target="_blank">Wikipedia</a></p>
            <p>Les règles du tournoi LOL organisé par le Play For Good #2 : <a
                href="https://docs.google.com/document/d/1wf_KwlL-nU3DgP1v8BT1r93R5P_LVilS/edit" target="_blank">ICI</a>
            </p>
        </div>
    </div>
    <div class="widget">
        <div class="widget-content">
            <h5>Information et inscription</h5>
            <iframe width="80%" height="480"
                    src="https://widget.toornament.com/tournaments/4559341706027319296/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Calendrier des games</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559341706027319296/matches/schedule/?_locale=fr"
                    frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Phase de groupe</h5>
            <iframe width="80%" height="480"
                    src="https://widget.toornament.com/tournaments/4559341706027319296/stages/4559411707115872256/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
    </div>
</div>

<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
